import { render, staticRenderFns } from "./trainingModulePageNew12.vue?vue&type=template&id=108d2b9a&scoped=true&"
import script from "./trainingModulePageNew12.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew12.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew12.vue?vue&type=style&index=0&id=108d2b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d2b9a",
  null
  
)

export default component.exports